import { render } from "./UpdateQueueDetails.vue?vue&type=template&id=70999480"
import script from "./UpdateQueueDetails.vue?vue&type=script&lang=js"
export * from "./UpdateQueueDetails.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__